import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createProject,
  deleteProject,
  getProjectDetail,
  getProjectList,
  updateProject,
} from '../../api/constlink';
import gHistory from '../../util/history';
import {
  createProjectAsync,
  CREATE_PROJECT,
  deleteProjectAsync,
  DELETE_PROJECT,
  getProjectDetailAsync,
  getProjectListAsync,
  GET_PROJECT_DETAIL,
  GET_PROJECT_LIST,
  updateProjectAsync,
  UPDATE_PROJECT,
} from './actions';
import { Project } from './types';

function* getProjectListSaga(
  action: ReturnType<typeof getProjectListAsync.request>,
) {
  try {
    const projects: Project[] = yield call(getProjectList, action.payload);
    yield put(getProjectListAsync.success(projects));
  } catch (e: any) {
    yield put(getProjectListAsync.failure(e));
  }
}

function* updateProjectSaga(
  action: ReturnType<typeof updateProjectAsync.request>,
) {
  try {
    const project: Project = yield call(updateProject, action.payload);
    yield put(updateProjectAsync.success(project));
  } catch (e: any) {
    yield put(updateProjectAsync.failure(e));
  }
}

function* createProjectSaga(
  action: ReturnType<typeof createProjectAsync.request>,
) {
  try {
    const project: Project = yield call(createProject, action.payload);
    yield put(createProjectAsync.success(project));
    gHistory.goBack();
  } catch (e: any) {
    yield put(createProjectAsync.failure(e));
  }
}

function* deleteProjectSaga(
  action: ReturnType<typeof deleteProjectAsync.request>,
) {
  try {
    const projectId: number = yield call(deleteProject, action.payload);
    yield put(deleteProjectAsync.success(projectId));
  } catch (e: any) {
    yield put(deleteProjectAsync.failure(e));
  }
}

function* getProjectDetailSaga(
  action: ReturnType<typeof getProjectDetailAsync.request>,
) {
  try {
    const project: Project = yield call(getProjectDetail, action.payload);
    yield put(getProjectDetailAsync.success(project));
  } catch (e: any) {
    yield put(getProjectDetailAsync.failure(e));
  }
}

export function* projectsSaga() {
  yield takeLatest(GET_PROJECT_LIST, getProjectListSaga);
  yield takeLatest(GET_PROJECT_DETAIL, getProjectDetailSaga);
  yield takeLatest(UPDATE_PROJECT, updateProjectSaga);
  yield takeLatest(CREATE_PROJECT, createProjectSaga);
  yield takeLatest(DELETE_PROJECT, deleteProjectSaga);
}
